<template>
  <div id="Flipbook">
      <v-container class="pa-0 upload-css">
        <v-layout v-if="templateEdit">
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="backTolisting">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
        <v-layout v-else>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute right @click="templateAddPage" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </v-container>  
      <v-container grid-list-md fluid v-if="!templateEdit">
      <v-card class="mt-1">
      <v-data-table
        disable-initial-sort
        :headers="flipbookHeaders"
        :items="PdfTemplate"
        :search="search"
        class="pf-data-table" 
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <tr v-if="MyAgencies">
            <td>{{ props.item.name }}</td>
            <td>{{ formatDate(props.item.createdAt, 'MM/DD/YYYY') }}</td>
            <td v-html="getAgencyNames(props.item.agency)"></td>
            <td width="280" align="right">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-0" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                  </template>
                    <span>Actions</span>
                  </v-tooltip>
                </v-btn>
                </template>
                <v-list class="flipbookOptions">
                  <v-list-tile :href="findPath(props.item.id)" target="_blank" v-if="(session.role() === 'parent' && Account.flipbook && Account.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1) || (session.role() === 'child' && Child.flipbook && Child.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">visibility</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     View
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="shareFlipbookLink(props.item)" v-if="(session.role() === 'parent' && Account.flipbook && Account.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1) || (session.role() === 'child' && Child.flipbook && Child.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">share</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Share
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="createFlipbook(props.item, 'new')" v-else>
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">menu_book</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Create flipbook
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="createFlipbook(props.item, 'recreate')" v-if="(session.role() === 'parent' && Account.flipbook && Account.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1) || (session.role() === 'child' && Child.flipbook && Child.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">loop</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Re-generate
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="addMetadata(props.item)" v-if="isHeyzine(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">groups</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Social media configuration
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="editItem(props.item)" v-if="totalActiveAgencies.length !== 1" :disabled="((session.getSession().adminUser && session.getSession().adminUser.role === 'agency') ? true : false)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">edit</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Change agency
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="session.getSession().adminUser && session.getSession().adminUser.role === 'admin'" target="_blank" :href="config.uploadPath + props.item.file.webPath">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">save_alt</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Save
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="deleteItem(props.item, 'admin')" v-if="session.getSession().adminUser && session.getSession().adminUser.role === 'admin'">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Delete template
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-else :disabled="((session.getSession().adminUser && session.getSession().adminUser.role === 'agency') ? true : false) || (session.role() === 'parent' && Account.flipbook && Account.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1) || (session.role() === 'child' && Child.flipbook && Child.flipbook.findIndex(pdf => pdf.pdf_template === props.item.id) !== -1)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Delete template
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
      </v-card>
      </v-container>
      <v-form v-else ref="formEdit">
        <v-container>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap row>
        <v-flex class="xs12 sm6 md7">
        <v-select 
            v-model="selectAgencies" 
            @change="changedData"
            :items="unselectedAgencies" 
            attach small-chips deletable-chips 
            label="Agencies" 
            :rules="rules"
            required
            multiple
            item-text="name"
            item-value="id"
            @input="changedData"
            class="pr-4 pl-4 required">
        </v-select>
        </v-flex>
        </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <app-modal :active="isShareFlipbook" v-if="isShareFlipbook" width="40%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="isShareFlipbook = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Share Flipbook Link</v-toolbar-title>
            </v-toolbar>
            <v-form ref="flipbookLinkShareForm">
              <v-card-text>
                <v-layout class="pt-1">
                  <v-flex>
                    <v-text-field v-model="sharedFlipbookLink" :rules="rules.email" label="Flipbook Link"
                    readonly
                    class="required pr-4 pl-4"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="pt-1">
                  <v-flex>
                    <v-text-field v-model.trim="flipbookShareData.email" :rules="[emailRules.email, emailRules.required]" label="To email address"
                    class="required pr-4 pl-4"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="pb-1 pt-1">
                  <v-flex>
                    <v-textarea v-model.trim="flipbookShareData.message" label="Your message (optional)"
                    class="pr-4 pl-4"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="isShareFlipbook = false"
              >
                Cancel
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="submitFlipbookLink"
              >
                Share
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
      <app-modal :active="isMetadataUpload" v-if="isMetadataUpload" width="80%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closeMetadataUpload">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Social media configuration</v-toolbar-title>
            </v-toolbar>
            <v-form ref="flipbookMetadataForm">
              <v-card-text>
                <v-layout class="pt-1">
                  <v-flex>
                    <v-text-field v-model="metadata.title" label="Title"
                    class="pr-4 pl-4"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="pt-1">
                  <v-flex>
                    <v-textarea v-model.trim="metadata.content" label="Description"
                    class="pr-4 pl-4"></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout class="pb-1 pt-1">
                  <v-flex class="mt-2">
                    <label class="ml-4" style="color: 'rgba(0,0,0,0.54); font-size: 16px;'">Preview image</label>
                    <v-select
                      class="pr-4 pl-4"
                      v-model="thumbnailChooseFrom"
                      :items="['Choose from albums', 'Upload new image']"
                      label="Select an option"
                      @change="closeImageCrop"
                    ></v-select>
                    <upload-btn
                      v-if="thumbnailChooseFrom === 'Upload new image'"
                      ref="metadataThumb"
                      :multiple="false"
                      @file-update="fileSelected($event)"
                      title="Select file"
                      maxWidth="200px"
                      accept="image/*"
                    >
                      <template slot="icon">
                        <v-icon right dark>cloud_upload</v-icon>
                      </template>
                      <template slot="text-field"></template>
                    </upload-btn>
                    <app-albums
                      v-else-if="thumbnailChooseFrom === 'Choose from albums'"
                      :accountId="this.Account.id"
                      :size="{ width: metaDataDimensions.width, height: metaDataDimensions.height }"
                      @submit="onSelectExistingImage"
                    />
                    <img v-if="croppedImage" width="300" :src="croppedImage" class="crop-preview-image" />
                    <v-flex class="mt-2 flex-column pr-4 pl-4">
                      <h4 class="mb-2">Minimum image resolutions</h4>
                      <span><b>Width: </b>{{ metaDataDimensions.width }} px</span>
                      <span><b>Height: </b>{{ metaDataDimensions.height }} px</span>
                      <span><b>Image needs to be square and should have the minimum dimensions mentioned above.</b></span>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-teal"
                @click="submitMetadata"
                :disabled="!!!croppedImage"
              >
                Upload
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeMetadataUpload"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>

      <app-modal :active="showCropImagePopup" v-if="showCropImagePopup && croppingImage" width="80%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeImageCrop">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crop the image</v-toolbar-title>
          </v-toolbar>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                v-if="croppedImage"
                class="pf-btn-text-white pf-bg-teal"
                @click="croppingImage = false"
              >
                Continue
              </v-btn>
              <v-btn
                v-if="!croppedImage"
                class="pf-btn-text-white pf-bg-teal"
                @click="cropImage"
                :disabled="false"
              >
                Crop Image
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeImageCrop"
                >
                Close
              </v-btn>
          </v-card-actions>
          <v-layout wrap class="mt-4 mb-4 flex-center pb-4">
              <cropper
                v-if="!croppedImage"
                class="cropper"
                ref="cropper"
                :src="croppingImage"
                :stencil-props="{
                  aspectRatio: 1.91 / 1,
                }"
                check-orientation
                :size-restrictions-algorithm="cropImageRestriction"
              ></cropper>
              <v-flex v-else class="flex-center">
                <img :src="croppedImage" class="crop-preview-image" />
              </v-flex>
          </v-layout>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>

<script>
/* global session store config */
import { getCollection, formatDate, request, uploadFile, create, remove, update, imageUrlToBase64, imageURLToBase64Direct } from '../helpers/helpers';
import swal from 'sweetalert2';
import UploadButton from 'vuetify-upload-button';
import { template } from '@babel/core';
import AppModal from '../components/AppModal';
import AppAlbums from '../components/AppAlbums';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default {
  name: 'Flipbook',
  components: {
    'upload-btn': UploadButton,
    'app-modal': AppModal,
    'app-albums': AppAlbums,
    Cropper
  },
  data: () => ({
    editIndex: -1,
    templateEdit: false,
    selectedData: false,
    selectAgencies: [],
    unselectedAgencies: [],
    disabledAgencies: [],
    editableTemplate: {},
    totalActiveAgencies: [],
    isShareFlipbook: false,
    sharedFlipbookLink: '',
    flipbookShareData: {
      email: '',
      message: ''
    },
    emailRules: {
      email: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
      required: value => !!value || 'Field is required.'
    },
    search: '',
    config: config,
    flipbookHeaders: [
      { text: 'Filename', value: 'name', align: 'left' },
      { text: 'Date', sortable: false },
      // { text: 'Directory', sortable: false },
      { text: 'Agency', sortable: false, width: '200px' },
      // { text: 'Type', value: 'type', width: '150px' },
      { text: '', sortable: false, width: '210px' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    rules: [
      v => (v) !== null && v.length !== 0 || 'select atleast one agency'
    ],
    isMetadataUpload: false,
    metadata: {
      title: '',
      content: '',
      file: ''
    },
    metaDataDimensions: {
      width: 600,
      height: 315
    },
    showCropImagePopup: false,
    croppingImage: null,
    croppedImage: null,
    thumbnailChooseFrom: '',
    currentFlipbook: null
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    MyAgencies: {
      get () {
        return store.state.MyAgencies;
      },
      set (value) {
        store.commit('setMyAgencies', value);
      }
    },
    PdfTemplate: {
      get () {
        return store.state.PdfTemplate;
      },
      set (value) {
        store.commit('setPdfTemplate', value);
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    }
  },
  async created () {
    await this.templateIntilize();
    if (this.PdfTemplate.length) {
      await this.initialize();
    }
    let statusList = ['Active', 'In Progress', 'Approved'];
    this.totalActiveAgencies = this.Account.agency.filter(agency => statusList.indexOf(agency.status) > -1);

    // Get the route param pdfTemplateId
    let pdfTemplateId = this.$route.params.pdfTemplateId;
    if (pdfTemplateId) {
      const pdfTemplate = this.PdfTemplate.find(pdf => pdf.id === pdfTemplateId);
      if (pdfTemplate) {
        this.addMetadata(pdfTemplate);
      }
    }
  },
  methods: {
    templateAddPage () {
      if (!this.totalActiveAgencies.length) {
        swal.fire({
          title: `<strong>No Active Agencies</strong>`,
          type: 'error',
          html: 'You don\'t have any agencies with Active, In Progress or Approved status to add PDF Profile',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close'
        });
      } else {
        this.$router.push({ name: 'pdfTemplateAdd', query: { preUrl: 'flipbook' }});
      }
    },
    getAgencyNames (pdfAgencies) {
      if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
        if (this.AdminAgency) {
          let list = this.AdminAgency.filter(agency => pdfAgencies.indexOf(agency.id) !== -1);
          return list.map(agency => agency.name).join(', <br/>');
        }
      } else {
        let list = this.MyAgencies.filter(agency => pdfAgencies.indexOf(agency.id) !== -1);
        return list.map(agency => agency.name).join(', <br/>');
      }
    },
    avaliableAgencies () {
      if (this.PdfTemplate.length) {
        
        let activeAgencies = Array.from(this.totalActiveAgencies, row => row.agency);

        let selectedAgenciesNotWithCurrentTemp = this.PdfTemplate.filter(template => template.id !== this.editableTemplate.id);
        let selectedAgencies = selectedAgenciesNotWithCurrentTemp.map(template => template.agency);
        let agenciesIds = selectedAgencies.flat();
        
        this.unselectedAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1 && agenciesIds.indexOf(agency.id) === -1);
        this.disabledAgencies = Array.filter(this.MyAgencies, agency => activeAgencies.indexOf(agency.id) !== -1 && agenciesIds.indexOf(agency.id) !== -1);

        this.disabledAgencies = this.disabledAgencies.map(agency => ({ ...agency, disabled: true }));
        this.unselectedAgencies = [...this.unselectedAgencies, ...this.disabledAgencies];
      }
      this.selectAgencies = [...this.editableTemplate.agency];
    },
    isHeyzine (item) {
      try {
        const flipbook = this.Account.flipbook.find(pdf => pdf.pdf_template === item.id);
        return Boolean(flipbook && flipbook.heyzine_data && flipbook.heyzine_data.id);
      } catch (e) {
        return false;
      }
    },
    async addMetadata (item) {
      const flipbook = this.Account.flipbook.find(pdf => pdf.pdf_template === item.id);
      if (flipbook) {
        this.isMetadataUpload = true;
        this.currentFlipbook = flipbook;
        const socialMetadata = flipbook.heyzine_data.social_metadata || {};
        this.metadata = {
          title: socialMetadata.title || '',
          content: socialMetadata.description || '',
          file: socialMetadata.thumbnail || ''
        };
        if (socialMetadata.thumbnail && !this.croppedImage) {
          try {
            // loading
            window.getApp.$emit('LoadingText', 'Loading thumbnail');
            window.getApp.$emit('AppProgress', true);
            this.croppedImage = await imageURLToBase64Direct(socialMetadata.thumbnail) || '';
            window.getApp.$emit('AppProgress', false);
            window.getApp.$emit('LoadingText', '');
          } catch (e) {
            window.getApp.$emit('AppProgress', false);
            window.getApp.$emit('LoadingText', '');
            this.snackbar = {
              show: true,
              color: 'red',
              text: `Failed to load thumbnail image. ${e.message}`
            };
          }
        }
      }
    },
    async fileSelected (file, type) {
      let self = this;
      if (file) {
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', async (image) => {
          let img = new Image();
          img.src = image.target.result;
          img.addEventListener('load', async (fileLoad) => {
            if (img.width < self.metaDataDimensions.width || img.height < self.metaDataDimensions.height) {
              swal.fire({
                type: 'warning',
                title: 'Invalid Resolution',
                text: `The image should have a minimum resolution of ${self.metaDataDimensions.width} x ${self.metaDataDimensions.height}`,
                showConfirmButton: true,
                onClose: () => {
                  window.getApp.$emit('AppProgress', false);
                  return;
                }
              });
              this.$refs.metadataThumb.clear();
              return;

            } else {
              this.croppedImage = null;
              /* Crop the image */
              this.openImageCrop(img.src);
            }
          });
        });
      }
    },
    openImageCrop (image) {
      if (image) {
        this.croppedImage = null;
        this.showCropImagePopup = true;
        this.croppingImage = image;
      }
    },
    cropImage () {
      const { canvas } = this.$refs.cropper.getResult();
      this.croppedImage = canvas.toDataURL();
      this.thumbnailChooseFrom = '';
    },
    cropImageRestriction ({ minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight }) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
      };
    },
    async submitMetadata () {
      let blobBin = atob(this.croppedImage.split(',')[1]);
      let unicodeArray = [];
      for (let i = 0; i < blobBin.length; i++) {
        unicodeArray.push(blobBin.charCodeAt(i));
      }
      let file = new File([new Uint8Array(unicodeArray)], `thumbnail-${Date.now()}.jpg`, { type: 'image/jpg' });
      await this.uploadCroppedImage(file);

    },
    closeImageCrop () {
      this.showCropImagePopup = false;
      this.croppingImage = null;
      if (this.$refs.metadataThumb) {
        this.$refs.metadataThumb.clear();
      }
    },
    closeMetadataUpload () {
      this.closeImageCrop();
      this.isMetadataUpload = false;
      this.$refs.flipbookMetadataForm.reset();
      this.currentFlipbook = null;
      if (this.$route.params.pdfTemplateId) {
        this.$router.push({ name: 'SocialMedia' });
      }
    },
    onSelectExistingImage (image) {
      if (image) {
        /* Crop the image */
        this.openImageCrop(image);
      }
    },
    async uploadCroppedImage (file) {
      let self = this;
      if (file) {
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', async (image) => {
          let img = new Image();
          img.src = image.target.result;
          img.addEventListener('load', async (fileLoad) => {
            
            if (img.width >= self.metaDataDimensions.width || img.height >= self.metaDataDimensions.height) {
              
              window.getApp.$emit('LoadingText', 'Saving social media configuration');
              window.getApp.$emit('AppProgress', true);
              let postUrl = 'Flipbook/Metadata';
              let extraParams = {
                account_id: this.Account.id,
                flipbook_id: this.currentFlipbook.heyzine_data.id,
                title: this.metadata.title,
                content: this.metadata.content,
                thumbnail: file
              };
              let response = await uploadFile(postUrl, file, 'POST', extraParams);
              if (response.$error) {
                // 
              } else {
                // Update the flipbook metadata
                if (response.$data && response.$data.heyzine_data) {
                  this.Account.flipbook = this.Account.flipbook.map(pdf => {
                    if (pdf.pdf_template === this.currentFlipbook.pdf_template) {
                      return response.$data;
                    }
                    return pdf;
                  });
                }
                swal.fire({
                  type: 'success',
                  title: 'Social media details updated successfully',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    window.getApp.$emit('AppProgress', false);
                    this.closeMetadataUpload();
                  }
                });
              }
              window.getApp.$emit('AppProgress', false);
              window.getApp.$emit('LoadingText', '');
            } else {
              swal.fire({
                type: 'warning',
                title: 'Invalid Resolution',
                text: `The image should have a minimum resolution of ${self.metaDataDimensions.width} x ${self.metaDataDimensions.height}`,
                showConfirmButton: true,
                onClose: () => {
                  window.getApp.$emit('AppProgress', false);
                  return;
                }
              });
              return;
            }
            if (this.$refs.cropper) {
              this.$refs.cropper.clear();
            }
          });
        });
      }
    },
    findPath (pdfId) {
      let path = this.Account.flipbook.find(pdf => (pdf.pdf_template === pdfId));
      return path.type === 'heyzine' ?
        path.heyzine_data.url :
        (config.uploadPath + path.flipbook);
    },
    shareFlipbookLink (item) {
      this.isShareFlipbook = true;
      this.sharedFlipbookLink = this.findPath(item.id);
    },
    async submitFlipbookLink () {
      if (this.$refs.flipbookLinkShareForm.validate()) {
        let payload = {
          toEmail: this.flipbookShareData.email,
          message: this.flipbookShareData.message,
          flipbook: this.sharedFlipbookLink
        };
        payload.account = this.Account.id;

        let { error, data, status } = await request('Email/shareFlipbookLink', 'POST', payload);
        if (error) {
          console.log('error', error);
        } else {
          this.flipbookShareData = {
            email: '',
            message: ''
          };
          this.sharedFlipbookLink = '';
          this.isShareFlipbook = false;
          swal.fire({
            type: 'success',
            title: 'Your message was sent successfully',
            showConfirmButton: true,
            timer: 2500,
            onClose: () => {
              /*  */
            }
          });
        }
      }
    },
    async templateIntilize () {
      // Initialize PDF templates
      if (!this.PdfTemplate.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where.account = sessionUser.user.human.account.id;
        }
        let { error, data, status } = await getCollection('PdfTemplate', true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load PdfTemplates'
          };
        } else {
          this.PdfTemplate = data.filter(pdf => {
            if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
              return pdf.agency.findIndex(agency => agency === session.getSession().adminUser.human.agency || (session.getSession().adminUser.human.agency.id && agency === session.getSession().adminUser.human.agency.id)) !== -1;
            }
            return true;
          });
        }
      }
    },
    async initialize () {
      // Initialize required agencies
      if (!this.MyAgencies.length) {
        let where = {
          'account.account': this.Account.id
        };
        let attributes = 'name,createdAt,account,child,_id';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.MyAgencies = data;
            if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') this.getAdminAgency();
          }
        }
      } else {
        if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') this.getAdminAgency();
      }
    },
    getAdminAgency () {
      this.AdminAgency = this.MyAgencies.filter(agency => agency.id === session.getSession().adminUser.human.agency);
    },
    formatDate (dateString, format) {
      return formatDate(dateString, format);
    },
    createFlipbook (pdf, mode) {
      let text = mode === 'new' ? 'Are you sure you want to create flipbook with this PDF?' : 'Are you sure you want to re-generate the flipbook?';
      swal.fire({
        title: 'Are you sure?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, proceed!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data: accountData, status } = await request('Flipbook/Generate', 'POST', { template: pdf.id });
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Something went wrong, please try again.'
              };
            } else {
              // Taken the old human since we have only id here
              accountData.human = this.Account.human;
              this.Account = accountData;
              // Create the timeline
              let timelineData = {
                title: 'Requested Flipbook',
                text: `You've requested to ${mode === 'new' ? 'generate' : 'regenerate'} a flipbook - '${pdf.name}'`,
              };
              timelineData.account = this.Account.id;

              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                swal.fire(
                  'Success!',
                  'Your request has been submitted, please check back in a few minutes',
                  'success'
                );
              }
            }
          })();
        }
      });
    },
    async editItem (item) {
      this.editableTemplate = { ...item };
      await this.avaliableAgencies();
      if (!this.unselectedAgencies.length) {
        swal.fire({
          title: `<strong>No Active Agencies</strong>`,
          type: 'error',
          html: 'You don\'t have any agencies with Active, In Progress or Approved status to edit PDF Profile',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close'
        });
      } else {
        this.templateEdit = true;
        this.editIndex = this.PdfTemplate.indexOf(item);
        window.getApp.$emit('pageSubHeader', 'Edit');
      }
    },
    async save () {
      if (this.$refs.formEdit.validate() && this.editIndex > -1) {
        this.selectedData = false;
        let { error, data, status } = await update('PdfTemplate', { agency: this.selectAgencies }, this.editableTemplate.id);
        if (error) {
          console.log('error', error);
          this.selectedData = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.PdfTemplate[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Template updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.templateEdit = false;
              this.selectedData = false;
              this.editableTemplate = {};
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    // @vuese
    // Used to go back to the flipbook listing from edit page
    backTolisting () {
      this.templateEdit = false;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    },
    changedData () {
      this.selectedData = true;
    },
    deleteItem (item, userType = 'parent') {
      let textMsg = '';
      if (item.agency.length === 1) {
        textMsg = `You won't be able to revert this!`;
      } else {
        textMsg = 'PDF will be deleted from all the agencies assigned. Please confirm whether to proceed?';
      }
      swal.fire({
        title: 'Are you sure?',
        text: textMsg,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('PdfTemplate', item.id);
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Something went wrong, please try again.'
              };
            } else {
              // Create the timeline
              let timelineData = {
                title: 'Profile PDF Deleted',
                text: `You've deleted a profile PDF - '${item.name}'`
              };
              timelineData.account = this.Account.id;

              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                const index = this.PdfTemplate.indexOf(item);
                this.PdfTemplate.splice(index, 1);
                if (userType === 'admin') {
                  let deletedItem = this.Account.flipbook.find(flipbook => flipbook.pdf_template === item.id);
                  this.Account.flipbook.splice(this.Account.flipbook.indexOf(deletedItem), 1);
                  this.Account = this.Account;
                }
                swal.fire(
                  'Deleted!',
                  'The PDF template "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            }
          })();
        }
      });
    },
  }
};
</script>

<style scoped>
.cropper {
  height: 500px;
}
.crop-preview-image {
  margin: 15px 25px;
  border: 3px solid teal;
  width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Flipbook.vue